import React, { useState, useEffect } from 'react';
import * as constants from '../../../../constant';
import MaskedInput from 'react-text-mask';
import { Col, Form, Row } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import BuscaEnderecoPorCEP from '../BuscaEnderecoPorCEP';
import { useDispatch } from 'react-redux';
import { buscarEndereco } from '../../../../Store/Prospecto/actions';
import { toast } from 'react-toastify';

const CamposEndereco = ({
  getAtualizarCidades,
  options,
  handleBlur,
  handleChange,
  values,
  setFieldValue,
  setValues,
  errors,
  touched,
}) => {
  const dispatch = useDispatch();
  const [tipoEndereco, setTipoEndereco] = useState(
    values.flg_endereco_correspondencia ? 'correspondencia' : 'principal'
  );
  useEffect(() => {
    setTipoEndereco(
      values.flg_endereco_correspondencia ? 'correspondencia' : 'principal'
    );
  }, [values.flg_endereco_correspondencia]);
  useEffect(() => {
    if (values.estado_correspondencia && values.estado_correspondencia !== '') {
      getAtualizarCidades(values.estado_correspondencia);
    }
  }, [values.estado_correspondencia, getAtualizarCidades]);

  useEffect(() => {
    if (
      values.flg_endereco_correspondencia &&
      values.cep_correspondencia &&
      values.cep_correspondencia.length > 0
    ) {
      const cepLimpo = values.cep_correspondencia.replace(/\D/g, '');
      if (cepLimpo.length === constants.TAMANHO_CEP) {
        dispatch(buscarEndereco(cepLimpo))
          .then(response => {
            preparaEnderecoCorrespondencia(response);
          })
          .catch(error => {
            toast.error('Erro ao buscar CEP de correspondência:', error);
          });
      }
    }
  }, [
    values.cep_correspondencia,
    values.flg_endereco_correspondencia,
    dispatch,
  ]);

  useEffect(() => {
    setTipoEndereco(
      values.flg_endereco_correspondencia ? 'correspondencia' : 'principal'
    );
  }, [values.flg_endereco_correspondencia]);

  useEffect(() => {
    if (values.estado_correspondencia && values.estado_correspondencia !== '') {
      getAtualizarCidades(values.estado_correspondencia);
    }
  }, [values.estado_correspondencia, getAtualizarCidades]);

  useEffect(() => {
    if (values.estado && values.estado !== '') {
      getAtualizarCidades(values.estado);
    }
  }, [values.estado, getAtualizarCidades]);

  useEffect(() => {
    if (
      values.estado &&
      values.cidade &&
      !values.codigo_cidade &&
      options.cidades &&
      options.cidades.length > 0
    ) {
      const normalize = s =>
        (s || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      const alvo = normalize(values.cidade);
      const found = options.cidades.find(c => normalize(c.descricao) === alvo);
      if (found) {
        setFieldValue('codigo_cidade', found.codigo);
      }
    }
  }, [values.estado, values.cidade, values.codigo_cidade, options.cidades, setFieldValue]);

  const filtroCidades = string => {
    return options.cidades
      .filter(cidades =>
        cidades.descricao.toLowerCase().includes(string.toLowerCase())
      )
      .map(item => ({
        value: item.codigo,
        label: item.descricao,
      }));
  };
  let timeout = null;
  const carregarCidades = (inputValue, callback) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback(filtroCidades(inputValue));
    }, 500);
  };
  const preparaEndereco = endereco => {
    setValues({
      ...values,
      ...endereco,
      endereco: endereco.logradouro,
      estado: endereco.uf,
      cep_invalido: false,
    });
    getAtualizarCidades(endereco.uf);
  };

  const handleCepValido = () => {
    setFieldValue('cep_invalido', false);
  };

  const handleCepInvalido = () => {
    setFieldValue('cep_invalido', true);
  };
  const preparaEnderecoCorrespondencia = endereco => {
    setValues({
      ...values,
      cep_correspondencia: endereco.cep,
      estado_correspondencia: endereco.uf,
      codigo_cidade_correspondencia:
        endereco.codigo_cidade || endereco.ibge || '',
      bairro_correspondencia: endereco.bairro,
      endereco_correspondencia: endereco.logradouro,
    });
    if (endereco.uf) {
      getAtualizarCidades(endereco.uf);
    }
  };
  const handleChangeCorrespondencia = event => {
    const { name, value } = event.target;
    setFieldValue(name, value);
  };
  const limpaEnderecoCorrespondencia = () => {
    setFieldValueCorrespondencia('codigo_cidade_correspondencia', null);
  };
  const setFieldValueCorrespondencia = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };
  return (
    <BuscaEnderecoPorCEP
      onChangeCEP={handleChange}
      quandoCarregarEndereco={endereco => preparaEndereco(endereco)}
      onCepValido={handleCepValido}
      onCepInvalido={handleCepInvalido}
    >
      {({ buscandoEndereco, erroBuscaEndereco, onChangeCEP }) => {
        return (
          <>
            <div className="row">
              <Col xs="12" md="6">
                <Form.Group controlId="prospecto.cep">
                  <Form.Label>CEP</Form.Label>
                  <MaskedInput
                    type="tel"
                    className={`form-control ${errors.cep &&
                      touched.cep &&
                      'is-invalid'}`}
                    name="cep"
                    onChange={onChangeCEP}
                    onBlur={handleBlur}
                    value={values.cep}
                    mask={constants.MASK_CEP}
                    placeholder="Ex.: 15015-820"
                    disabled={buscandoEndereco}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.cep}
                  </Form.Control.Feedback>
                  {erroBuscaEndereco && (
                    <small className="form-text text-danger">
                      {erroBuscaEndereco}
                    </small>
                  )}
                </Form.Group>
                <Form.Group controlId="prospecto.estado">
                  <Form.Label>Estado</Form.Label>
                  <Form.Control
                    as="select"
                    className="form-control"
                    name="estado"
                    onChange={event => {
                      getAtualizarCidades(event.target.value);
                      handleChange(event);
                      setFieldValue('codigo_cidade', '');
                    }}
                    onBlur={handleBlur}
                    value={values.estado}
                    disabled={buscandoEndereco}
                    isInvalid={errors.estado && touched.estado}
                  >
                    <option value="">Selecione um estado</option>
                    {constants.ESTADOS.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.estado}
                  </Form.Control.Feedback>
                </Form.Group>
                {values.estado &&
                  options.cidades &&
                  options.cidades.length > 0 && (
                    <Form.Group controlId="prospecto.codigo_cidade">
                      <Form.Label>Cidade</Form.Label>
                      <AsyncSelect
                        isDisabled={
                          options.cidades.length === 0 || buscandoEndereco
                        }
                        isLoading={options.cidades.length === 0}
                        loadingMessage={() => 'Carregando...'}
                        noOptionsMessage={() =>
                          'Digite uma cidade. Ex.: Rio Preto'
                        }
                        placeholder="Pesquisar cidades..."
                        loadOptions={carregarCidades}
                        onChange={option => {
                          setFieldValue('codigo_cidade', option.value);
                        }}
                        value={
                          values.codigo_cidade &&
                          options.cidades.length > 0 &&
                          options.cidadesById[values.codigo_cidade]
                            ? {
                                value: parseInt(
                                  options.cidadesById[values.codigo_cidade]
                                    .codigo
                                ),
                                label:
                                  options.cidadesById[values.codigo_cidade]
                                    .descricao,
                              }
                            : {
                                value: '',
                                label:
                                  options.cidades.length === 0
                                    ? 'Carregando...'
                                    : 'Selecione uma cidade',
                              }
                        }
                      />
                      {errors.codigo_cidade && (
                        <small className="form-text text-danger">
                          {errors.codigo_cidade}
                        </small>
                      )}
                    </Form.Group>
                  )}
                <Form.Group controlId="prospecto.bairro">
                  <Form.Label>Bairro</Form.Label>
                  <Form.Control
                    type="text"
                    className="form-control"
                    name="bairro"
                    maxLength="20"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.bairro.substring(0, 20)}
                    placeholder="Ex.: Redentora"
                    disabled={buscandoEndereco}
                    isInvalid={errors.bairro && touched.bairro}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bairro}
                  </Form.Control.Feedback>
                </Form.Group>
                {values.codigo_conta && (
                  <>
                    <Form.Label>Endereço de Correspondência</Form.Label>
                    <Row className="p-3">
                      <Form.Check
                        type="radio"
                        id="endereco-principal"
                        name="tipoEndereco"
                        label="Usar endereço principal"
                        checked={tipoEndereco === 'principal'}
                        onChange={() => {
                          setTipoEndereco('principal');
                          setFieldValue('flg_endereco_correspondencia', false);
                        }}
                        className="mr-3"
                        onClick={limpaEnderecoCorrespondencia}
                      />
                      <Form.Check
                        type="radio"
                        id="endereco-correspondencia"
                        name="tipoEndereco"
                        label="Usar endereço correspondência"
                        checked={tipoEndereco === 'correspondencia'}
                        onChange={() => {
                          setTipoEndereco('correspondencia');
                          setFieldValue('flg_endereco_correspondencia', true);
                        }}
                      />
                    </Row>
                  </>
                )}
              </Col>
              <Col xs="12" md="6">
                <Form.Group controlId="prospecto.endereco">
                  <Form.Label>Endereço</Form.Label>
                  <Form.Control
                    type="text"
                    name="endereco"
                    maxLength="40"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.endereco}
                    placeholder="Ex.: Rua Penita"
                    disabled={buscandoEndereco}
                    isInvalid={errors.endereco && touched.endereco}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.endereco}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="prospecto.numero">
                  <Form.Label>Número</Form.Label>
                  <Form.Control
                    type="number"
                    name="numero"
                    maxLength="10"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.numero}
                    placeholder="Ex.: 3355"
                    disabled={buscandoEndereco}
                    isInvalid={errors.numero && touched.numero}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.numero}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="prospecto.complemento">
                  <Form.Label>Complemento</Form.Label>
                  <Form.Control
                    type="text"
                    name="complemento"
                    maxLength="30"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.complemento}
                    placeholder="Ex.: Setpar"
                    disabled={buscandoEndereco}
                  />
                </Form.Group>
              </Col>
            </div>
            <div className="row">
              {tipoEndereco === 'correspondencia' && (
                <BuscaEnderecoPorCEP
                  onChangeCEP={event => {
                    const { name, value } = event.target;
                    setFieldValue(name, value);
                  }}
                  quandoCarregarEndereco={endereco =>
                    preparaEnderecoCorrespondencia(endereco)
                  }
                >
                  {({
                    buscandoEndereco: buscandoEnderecoCorr,
                    erroBuscaEndereco: erroBuscaEnderecoCorr,
                    onChangeCEP: onChangeCEPCorr,
                  }) => (
                    <>
                      <Col xs="12" md="6">
                        <Form.Group controlId="correspondencia.cep">
                          <Form.Label>CEP</Form.Label>
                          <MaskedInput
                            type="tel"
                            className={`form-control ${values.flg_endereco_correspondencia &&
                              errors.cep_correspondencia &&
                              touched.cep_correspondencia &&
                              'is-invalid'}`}
                            name="cep_correspondencia"
                            onChange={onChangeCEPCorr}
                            onBlur={handleBlur}
                            value={values.cep_correspondencia || ''}
                            mask={constants.MASK_CEP}
                            placeholder="Ex.: 15015-820"
                            disabled={buscandoEnderecoCorr}
                          />
                          {values.flg_endereco_correspondencia && (
                            <Form.Control.Feedback type="invalid">
                              {errors.cep_correspondencia}
                            </Form.Control.Feedback>
                          )}
                          {erroBuscaEnderecoCorr && (
                            <small className="form-text text-danger">
                              {erroBuscaEnderecoCorr}
                            </small>
                          )}
                        </Form.Group>
                        <Form.Group controlId="correspondencia.estado">
                          <Form.Label>Estado</Form.Label>
                          <Form.Control
                            as="select"
                            className="form-control"
                            name="estado_correspondencia"
                            onChange={event => {
                              handleChangeCorrespondencia(event);
                              setFieldValueCorrespondencia(
                                'codigo_cidade_correspondencia',
                                ''
                              );
                              getAtualizarCidades(event.target.value);
                            }}
                            value={values.estado_correspondencia || ''}
                            disabled={buscandoEnderecoCorr}
                          >
                            <option value="">Selecione um estado</option>
                            {constants.ESTADOS.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        {values.estado_correspondencia &&
                          options.cidades &&
                          options.cidades.length > 0 && (
                            <Form.Group controlId="correspondencia.codigo_cidade">
                              <Form.Label>Cidade</Form.Label>
                              <AsyncSelect
                                isDisabled={
                                  options.cidades.length === 0 ||
                                  buscandoEnderecoCorr
                                }
                                isLoading={options.cidades.length === 0}
                                loadingMessage={() => 'Carregando...'}
                                noOptionsMessage={() =>
                                  'Digite uma cidade. Ex.: Rio Preto'
                                }
                                placeholder="Pesquisar cidades..."
                                loadOptions={carregarCidades}
                                onChange={option => {
                                  setFieldValueCorrespondencia(
                                    'codigo_cidade_correspondencia',
                                    option.value
                                  );
                                }}
                                value={
                                  values.codigo_cidade_correspondencia &&
                                  options.cidades.length > 0 &&
                                  options.cidadesById[
                                    values.codigo_cidade_correspondencia
                                  ]
                                    ? {
                                        value: parseInt(
                                          options.cidadesById[
                                            values.codigo_cidade_correspondencia
                                          ].codigo
                                        ),
                                        label:
                                          options.cidadesById[
                                            values.codigo_cidade_correspondencia
                                          ].descricao,
                                      }
                                    : {
                                        value: '',
                                        label:
                                          options.cidades.length === 0
                                            ? 'Carregando...'
                                            : 'Selecione uma cidade',
                                      }
                                }
                              />
                              {errors.codigo_cidade_correspondencia && (
                                <small className="form-text text-danger">
                                  {errors.codigo_cidade_correspondencia}
                                </small>
                              )}
                            </Form.Group>
                          )}

                        <Form.Group controlId="correspondencia.bairro">
                          <Form.Label>Bairro</Form.Label>
                          <Form.Control
                            type="text"
                            className="form-control"
                            name="bairro_correspondencia"
                            maxLength="20"
                            onChange={handleChangeCorrespondencia}
                            value={(
                              values.bairro_correspondencia || ''
                            ).substring(0, 20)}
                            placeholder="Ex.: Redentora"
                            disabled={buscandoEnderecoCorr}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group controlId="correspondencia.endereco">
                          <Form.Label>Endereço</Form.Label>
                          <Form.Control
                            type="text"
                            name="endereco_correspondencia"
                            maxLength="40"
                            onChange={handleChangeCorrespondencia}
                            value={values.endereco_correspondencia || ''}
                            placeholder="Ex.: Rua Penita"
                            disabled={buscandoEnderecoCorr}
                          />
                        </Form.Group>

                        <Form.Group controlId="correspondencia.numero">
                          <Form.Label>Número</Form.Label>
                          <Form.Control
                            type="number"
                            name="numero_correspondencia"
                            maxLength="10"
                            onChange={handleChangeCorrespondencia}
                            value={values.numero_correspondencia || ''}
                            placeholder="Ex.: 3355"
                            disabled={buscandoEnderecoCorr}
                          />
                        </Form.Group>
                        <Form.Group controlId="correspondencia.complemento">
                          <Form.Label>Complemento</Form.Label>
                          <Form.Control
                            type="text"
                            name="complemento_correspondencia"
                            maxLength="30"
                            onChange={handleChangeCorrespondencia}
                            onBlur={handleBlur}
                            value={values.complemento_correspondencia || ''}
                            placeholder="Ex.: Setpar"
                            disabled={buscandoEnderecoCorr}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}
                </BuscaEnderecoPorCEP>
              )}
            </div>
          </>
        );
      }}
    </BuscaEnderecoPorCEP>
  );
};

export default CamposEndereco;
